import { Box } from "@mui/material";
import { styled, keyframes } from "@mui/material/styles";
import React from "react";
import { BrandMark, BrandWordmark } from "components";

const breathe = keyframes`
  0%, 100% { transform: scale(1); opacity: 0.95; }
  50% { transform: scale(1.06); opacity: 1; }
`;

const bounce = keyframes`
  0%, 80%, 100% { transform: scale(0.4); opacity: 0.5; }
  40% { transform: scale(1); opacity: 1; }
`;

const sheen = keyframes`
  0% { transform: translateX(-120%) skewX(-12deg); }
  100% { transform: translateX(220%) skewX(-12deg); }
`;

const Root = styled(Box)({
  position: "fixed",
  inset: 0,
  background: "linear-gradient(135deg, #faf2d2 0%, #eeeeee 50%, #e1f5f3 100%)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
  overflow: "hidden",
});

const Center = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 20,
  position: "relative",
});

const LogoWrap = styled(Box)({
  position: "relative",
  width: 128,
  height: 128,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  overflow: "hidden",
  borderRadius: 24,
  "&::after": {
    content: '""',
    position: "absolute",
    top: 0,
    bottom: 0,
    width: "40%",
    background:
      "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.55) 50%, rgba(255,255,255,0) 100%)",
    animation: `${sheen} 2.6s ease-in-out infinite`,
    pointerEvents: "none",
    zIndex: 1,
  },
});

const breatheSx = {
  animation: `${breathe} 2.4s ease-in-out infinite`,
  filter: "drop-shadow(0 10px 24px rgba(46,196,182,0.35))",
};

const Dots = styled(Box)({
  display: "flex",
  gap: 10,
  marginTop: 4,
});

const Dot = styled(Box, { shouldForwardProp: (p) => p !== "delay" })(({ delay }) => ({
  width: 10,
  height: 10,
  borderRadius: "50%",
  background: "#2ec4b6",
  animation: `${bounce} 1.4s ease-in-out ${delay}s infinite both`,
}));

const FullScreenSpinner = () => {
  return (
    <Root role="status" aria-live="polite" aria-label="Loading Groupardy">
      <Center>
        <LogoWrap>
          <BrandMark size="xl" alt="" sx={breatheSx} />
        </LogoWrap>
        <BrandWordmark size="xl" variant="light" />
        <Dots aria-hidden="true">
          <Dot delay={-0.32} />
          <Dot delay={-0.16} />
          <Dot delay={0} />
        </Dots>
      </Center>
    </Root>
  );
};

export { FullScreenSpinner };
